import React from 'react'
import clsx from 'clsx'

type Props = {
	children?: React.ReactNode
	even?: boolean
}

const DatatableRow = ({ children, even = false }: Props) => {
	return <div className={clsx({ 'min-w-full py-4 lg:py-0 lg:table-row': true, 'bg-gray-100': even })}>{children}</div>
}

export default DatatableRow
